import { fetcher } from '@commenda/utils';

enum MailroomAddressType {
  MAILING_ADDRESS = 'MAILING_ADDRESS',
  // REGISTERED_AGENT_ADDRESS = "REGISTERED_AGENT_ADDRESS", // Our current mailroom provider stable does not support this via API
}

export type TCreateLocationParams = {
  corporationId: number;
};

export async function createLocation(params: TCreateLocationParams) {
  const res = await fetcher(`mailroom/admin/location`, {
    method: 'POST',
    body: {
      addressType: MailroomAddressType.MAILING_ADDRESS,
      corporationId: params.corporationId,
    },
  });

  if (!res.ok) {
    return {
      success: false,
      message: 'Failed to add location.',
    };
  }

  return {
    success: true,
    message: 'Location added successfully.',
  };
}
